import React from "react";
import { Star, ChevronDown, ChevronRight, X, Phone } from "lucide-react";
import { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import Logo from "./Logo";
import { useScrollDirection } from "../hooks/useScrollDirection";
function Header() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isOverOnsOpen, setIsOverOnsOpen] = useState(false);
  const [isDienstenOpen, setIsDienstenOpen] = useState(false);
  const overOnsRef = useRef<HTMLDivElement>(null);
  const dienstenRef = useRef<HTMLDivElement>(null);
  const { scrollDirection, scrolledToTop } = useScrollDirection();
  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (
        overOnsRef.current &&
        !overOnsRef.current.contains(event.target as Node)
      ) {
        setIsOverOnsOpen(false);
      }
      if (
        dienstenRef.current &&
        !dienstenRef.current.contains(event.target as Node)
      ) {
        setIsDienstenOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);
  return (
    <div
      className={`fixed w-full transition-transform duration-300 z-[999] top-0 ${
        isMobileMenuOpen ? "h-screen" : ""
      } ${
        scrolledToTop || isMobileMenuOpen
          ? "translate-y-0"
          : scrollDirection === "up" || isMobileMenuOpen
          ? "translate-y-0 shadow-lg"
          : "-translate-y-full"
      }`}
      style={{ backgroundColor: "#2FB6D2", marginBottom: 0 }}
    >
      {/* Top Bar */}
      <div className="w-full">
        <div
          className="border-b border-solid border-white/20"
          style={{ backgroundColor: "#2FB6D2" }}
        >
          <section className="mx-auto w-[calc(100%-2.5rem)] max-w-[1260px] flex h-11 items-center justify-between">
            <div className="flex align-bottom items-center gap-3">
              <div className="text-[14px] font-medium text-white">4.7</div>
              <div className="flex items-center gap-1">
                {[...Array(5)].map((_, i) => {
                  if (i < 4) {
                    // Fully filled stars
                    return (
                      <Star
                        key={i}
                        className="w-3 h-3"
                        fill="#FDBB00"
                        stroke="#FDBB00"
                      />
                    );
                  } else if (i === 4) {
                    // Half-filled star
                    return (
                      <svg key={i} className="w-3 h-3" viewBox="0 0 24 24">
                        <path
                          d="M12 2L15.09 8.63L22 9.24L17 14.14L18.18 21L12 17.27L5.82 21L7 14.14L2 9.24L8.91 8.63L12 2Z"
                          fill="none"
                          stroke="#FDBB00"
                          strokeWidth="2"
                        />
                        <clipPath id="halfStarClip">
                          <rect x="0" y="0" width="12" height="24" />
                        </clipPath>
                        <path
                          d="M12 2L15.09 8.63L22 9.24L17 14.14L18.18 21L12 17.27L5.82 21L7 14.14L2 9.24L8.91 8.63L12 2Z"
                          fill="#FDBB00"
                          clipPath="url(#halfStarClip)"
                        />
                      </svg>
                    );
                  } else {
                    // Empty stars
                    return (
                      <Star
                        key={i}
                        className="w-3 h-3"
                        fill="none"
                        stroke="#FDBB00"
                      />
                    );
                  }
                })}
              </div>

              <div className="text-[14px] font-medium text-white">
                128 beoordelingen
              </div>
            </div>
            <div className="items-center hidden lg:flex gap-8">
              <div className="relative" ref={overOnsRef}>
                <button
                  onClick={() => setIsOverOnsOpen(!isOverOnsOpen)}
                  className="flex items-center gap-[2px] transition-opacity duration-150 hover:opacity-80"
                >
                  <div className="text-[14px] font-medium text-white">
                    Over ons
                  </div>
                  <ChevronDown
                    className={`w-4 h-4 text-white mt-[1px] transition-transform duration-200 ${
                      isOverOnsOpen ? "rotate-180" : ""
                    }`}
                  />
                </button>
                {isOverOnsOpen && (
                  <div className="absolute top-full left-0 mt-2 w-48 bg-white rounded-lg shadow-lg py-2 z-50">
                    <Link
                      to="/ons-verhaal"
                      className="block px-4 py-2 text-gray-800 hover:bg-gray-100"
                      onClick={() => setIsOverOnsOpen(false)}
                    >
                      Ons verhaal
                    </Link>
                    <Link
                      to="/vacatures"
                      className="block px-4 py-2 text-gray-800 hover:bg-gray-100"
                      onClick={() => setIsOverOnsOpen(false)}
                    >
                      Vacatures
                    </Link>
                    <Link
                      to="/veelgestelde-vragen"
                      className="block px-4 py-2 text-gray-800 hover:bg-gray-100"
                      onClick={() => setIsOverOnsOpen(false)}
                    >
                      Veelgestelde vragen
                    </Link>
                  </div>
                )}
              </div>
              <Link
                to="/klantenservice"
                className="transition-opacity duration-150 hover:opacity-80"
              >
                <div className="text-[14px] font-medium text-white">
                  Klantenservice
                </div>
              </Link>
              <Link
                to="/contact"
                className="transition-opacity duration-150 hover:opacity-80"
              >
                <div className="text-[14px] font-medium text-white">
                  Contact
                </div>
              </Link>
            </div>
          </section>
        </div>
        {/* Main Navigation */}
        <div
          className="border-b border-solid border-white/20"
          style={{ backgroundColor: "#2FB6D2" }}
        >
          <section className="mx-auto w-[calc(100%-2.5rem)] max-w-[1260px] flex items-center h-[60px] justify-between gap-6 md:h-[88px]">
            <Logo />
            <div className="flex items-center gap-10">
              {/* Desktop Diensten Dropdown */}

              <a
                href="/"
                className="flex items-center gap-[2px] transition-opacity duration-150 hover:opacity-80"
              >
                <div className="hidden lg:block text-[16px] font-medium text-white">
                  Home
                </div>
              </a>

              <div className="relative hidden lg:block" ref={dienstenRef}>
                <button
                  onClick={() => setIsDienstenOpen(!isDienstenOpen)}
                  className="flex items-center gap-[2px] transition-opacity duration-150 hover:opacity-80"
                >
                  <div className="text-[16px] font-medium text-white">
                    Diensten
                  </div>
                  <ChevronDown
                    className={`w-4 h-4 text-white mt-[1px] transition-transform duration-200 ${
                      isDienstenOpen ? "rotate-180" : ""
                    }`}
                  />
                </button>

                {isDienstenOpen && (
                  <div className="absolute top-full left-0 mt-8 w-[400px] bg-white rounded-lg shadow-lg p-4 z-50 space-y-2">
                    <Link
                      to="/groepenkast-vervangen"
                      className="flex items-center px-3 py-2 bg-white rounded-2xl border border-[#E5E7EB] hover:border-[#17354A]/50 transition-colors duration-150"
                      onClick={() => setIsDienstenOpen(false)}
                    >
                      <div className="w-6 h-6 flex-shrink-0 overflow-hidden rounded-lg">
                        <img
                          src="/images/el.svg"
                          alt="groepenkast vervangen"
                          className="w-6 h-6 object-cover"
                        />
                      </div>
                      <span className="ml-4 text-[#17354A] text-md font-medium">
                        Groepenkast vervangen
                      </span>
                      <ChevronRight className="w-5 h-5 text-[#17354A] ml-auto" />
                    </Link>

                    <Link
                      to="/kookgroep-aansluiten"
                      className="flex items-center px-3 py-2 bg-white rounded-2xl border border-[#E5E7EB] hover:border-[#17354A]/50 transition-colors duration-150"
                      onClick={() => setIsDienstenOpen(false)}
                    >
                      <div className="w-6 h-6 flex-shrink-0 overflow-hidden rounded-lg">
                        <img
                          src="/images/kookgroep.svg"
                          alt="kookgroep aansluiten"
                          className="w-6 h-6 object-cover"
                        />
                      </div>
                      <span className="ml-4 text-[#17354A] text-md font-medium">
                        Kookgroep aansluiten
                      </span>
                      <ChevronRight className="w-5 h-5 text-[#17354A] ml-auto" />
                    </Link>
                    <Link
                      to="/elektra-renovatie"
                      className="flex items-center px-3 py-2 bg-white rounded-2xl border border-[#E5E7EB] hover:border-[#17354A]/50 transition-colors duration-150"
                      onClick={() => setIsDienstenOpen(false)}
                    >
                      <div className="w-6 h-6 flex-shrink-0 overflow-hidden rounded-lg">
                        <img
                          src="/images/electric.svg"
                          alt="Elektra renovatie"
                          className="w-6 h-6 object-cover"
                        />
                      </div>
                      <span className="ml-4 text-[#17354A] text-md font-medium">
                        Elektra renovatie
                      </span>
                      <ChevronRight className="w-5 h-5 text-[#17354A] ml-auto" />
                    </Link>
                    <Link
                      to="/3-fase-aansluiting"
                      className="flex items-center px-3 py-2 bg-white rounded-2xl border border-[#E5E7EB] hover:border-[#17354A]/50 transition-colors duration-150"
                      onClick={() => setIsDienstenOpen(false)}
                    >
                      <div className="w-6 h-6 flex-shrink-0 overflow-hidden rounded-lg">
                        <img
                          src="/images/meterkast.svg"
                          alt="3 fase aansluiting"
                          className="w-6 h-6 object-cover"
                        />
                      </div>
                      <span className="ml-4 text-[#17354A] text-md font-medium">
                        3 fase aansluiting
                      </span>
                      <ChevronRight className="w-5 h-5 text-[#17354A] ml-auto" />
                    </Link>
                    <Link
                      to="/elektra-aanleggen"
                      className="flex items-center px-3 py-2 bg-white rounded-2xl border border-[#E5E7EB] hover:border-[#17354A]/50 transition-colors duration-150"
                      onClick={() => setIsDienstenOpen(false)}
                    >
                      <div className="w-6 h-6 flex-shrink-0 overflow-hidden rounded-lg">
                        <img
                          src="/images/elektra-aanleg.svg"
                          alt="Elektra aanleggen"
                          className="w-6 h-6 object-cover"
                        />
                      </div>
                      <span className="ml-4 text-[#17354A] text-md font-medium">
                        Elektra aanleggen
                      </span>
                      <ChevronRight className="w-5 h-5 text-[#17354A] ml-auto" />
                    </Link>
                    <Link
                      to="/laadpaal"
                      className="flex items-center px-3 py-2 bg-white rounded-2xl border border-[#E5E7EB] hover:border-[#17354A]/50 transition-colors duration-150"
                      onClick={() => setIsDienstenOpen(false)}
                    >
                      <div className="w-6 h-6 flex-shrink-0 overflow-hidden rounded-lg">
                        <img
                          src="/images/ev.svg"
                          alt="Laadpaal"
                          className="w-6 h-6 object-cover"
                        />
                      </div>
                      <span className="ml-4 text-[#17354A] text-md font-medium">
                        Laadpaal installatie
                      </span>
                      <ChevronRight className="w-5 h-5 text-[#17354A] ml-auto" />
                    </Link>
                    <Link
                      to="/zonnepanelen"
                      className="flex items-center px-3 py-2 bg-white rounded-2xl border border-[#E5E7EB] hover:border-[#17354A]/50 transition-colors duration-150"
                      onClick={() => setIsDienstenOpen(false)}
                    >
                      <div className="w-6 h-6 flex-shrink-0 overflow-hidden rounded-lg">
                        <img
                          src="/images/solar.svg"
                          alt="zonnepanelen"
                          className="w-6 h-6 object-cover"
                        />
                      </div>
                      <span className="ml-4 text-[#17354A] text-md font-medium">
                        Zonnepanelen installatie
                      </span>
                      <ChevronRight className="w-5 h-5 text-[#17354A] ml-auto" />
                    </Link>
                    <Link
                      to="/inspectie"
                      className="flex items-center px-3 py-2 bg-white rounded-2xl border border-[#E5E7EB] hover:border-[#17354A]/50 transition-colors duration-150"
                      onClick={() => setIsDienstenOpen(false)}
                    >
                      <div className="w-6 h-6 flex-shrink-0 overflow-hidden rounded-lg">
                        <img
                          src="/images/inspectie.svg"
                          alt="inspectie"
                          className="w-6 h-6 object-cover"
                        />
                      </div>
                      <span className="ml-4 text-[#17354A] text-md font-medium">
                        Elektra inspectie
                      </span>
                      <ChevronRight className="w-5 h-5 text-[#17354A] ml-auto" />
                    </Link>
                  </div>
                )}
              </div>

              {/* Mobile Menu Button */}
              <div className="flex lg:hidden gap-4 items-center">
                <button
                  onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                  className="flex justify-center items-center text-white"
                >
                  <svg viewBox="0 0 32 32" width="32" height="32">
                    <path
                      d="M5.43 8h21.14M5.43 16h21.14M5.43 24h21.14"
                      stroke="currentColor"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                    />
                  </svg>
                </button>
              </div>
              {/* Desktop CTA */}
              <div className="hidden lg:flex gap-4 items-center">
                <Link
                  to="tel:+31852129778"
                  className="relative font-medium transition-all duration-150 leading-normal outline-none inline-flex border-2 border-transparent items-center justify-center rounded-full active:scale-[.98] text-base px-5 h-12 leading-[48px] bg-transparent text-white border border-white hover:text-[#2FB6D2] hover:bg-white focus:bg-white/80 min-w-[155px]"
                >
                  <span className="flex items-center gap-1">
                    085-2129778
                    <ChevronDown className="w-4 h-4 rotate-[-90deg]" />
                  </span>
                </Link>

                <Link
                  to="/offerte"
                  aria-label="Vraag een vrijblijvende offerte aan voor groepenkast vervanging"
                  className="relative font-medium transition-all duration-150 leading-normal outline-none inline-flex border-2 border-transparent items-center justify-center rounded-full active:scale-[.98] text-base px-5 h-12 leading-[48px] bg-white text-[#2FB6D2] hover:bg-white/80 focus:bg-white/80 min-w-[155px]"
                >
                  <span className="flex items-center gap-1">
                    Gratis offerte
                    <ChevronDown className="w-4 h-4 rotate-[-90deg]" />
                  </span>
                </Link>
              </div>
            </div>
          </section>
        </div>
        {/* Sticky Phone Bar */}
        <div className="w-full bg-[#17354A] text-white lg:hidden sticky top-0 h-10">
          <div className="mx-auto w-[calc(100%-2.5rem)] max-w-[1260px] h-full flex justify-between items-center">
            <a
              href="tel:+31852129778"
              className="gap-2 text-white bg-transparent border hover:text-[#17354A] border-white text-sm font-medium px-3 h-7 rounded-full flex items-center hover:bg-white transition-colors"
            >
              <Phone className="w-4 h-4" />
              <span className="text-sm font-medium">085-2129778</span>
            </a>
            <Link
              to="/offerte"
              aria-label="Vraag een vrijblijvende offerte aan voor groepenkast vervanging"
              className="bg-white text-[#17354A] text-sm font-medium px-3 h-7 rounded-full flex items-center hover:bg-white/90 transition-colors"
            >
              Gratis offerte
            </Link>
          </div>
        </div>
      </div>
      {/* Mobile Menu Overlay */}
      {isMobileMenuOpen && (
        <div className="absolute inset-0 bg-[#2FB6D2] z-[100] lg:hidden overflow-y-auto min-h-screen">
          <div className="px-4 py-2 flex justify-between items-center border-b border-white/20">
            <Link to="/" className="flex items-center gap-2 leading-none">
              <span className="text-xl font-['Pacifico'] text-white">
                elektra
              </span>
              <span className="text-lg font-['Pacifico'] text-white/90">
                aanleggenn
              </span>
            </Link>
            <button
              onClick={() => setIsMobileMenuOpen(false)}
              className="text-white"
            >
              <X className="w-5 h-5" />
            </button>
          </div>
          <div className="p-6 space-y-6">
            <div className="space-y-3">
              <Link
                to="/groepenkast-vervangen"
                className="flex items-center px-3 py-2 bg-white rounded-2xl border border-[#E5E7EB] hover:border-[#17354A]/50 transition-colors duration-150"
                onClick={() => setIsDienstenOpen(false)}
              >
                <div className="w-6 h-6 flex-shrink-0 overflow-hidden rounded-lg">
                  <img
                    src="/images/el.svg"
                    alt="groepenkast vervangen"
                    className="w-6 h-6 object-cover"
                  />
                </div>
                <span className="ml-4 text-[#17354A] text-md font-medium">
                  Groepenkast vervangen
                </span>
                <ChevronRight className="w-5 h-5 text-[#17354A] ml-auto" />
              </Link>

              <Link
                to="/kookgroep-aansluiten"
                className="flex items-center px-3 py-2 bg-white rounded-2xl border border-[#E5E7EB] hover:border-[#17354A]/50 transition-colors duration-150"
                onClick={() => setIsDienstenOpen(false)}
              >
                <div className="w-6 h-6 flex-shrink-0 overflow-hidden rounded-lg">
                  <img
                    src="/images/kookgroep.svg"
                    alt="kookgroep aansluiten"
                    className="w-6 h-6 object-cover"
                  />
                </div>
                <span className="ml-4 text-[#17354A] text-md font-medium">
                  Kookgroep aansluiten
                </span>
                <ChevronRight className="w-5 h-5 text-[#17354A] ml-auto" />
              </Link>
              <Link
                to="/elektra-renovatie"
                className="flex items-center px-3 py-2 bg-white rounded-2xl border border-[#E5E7EB] hover:border-[#17354A]/50 transition-colors duration-150"
                onClick={() => setIsDienstenOpen(false)}
              >
                <div className="w-6 h-6 flex-shrink-0 overflow-hidden rounded-lg">
                  <img
                    src="/images/electric.svg"
                    alt="Elektra renovatie"
                    className="w-6 h-6 object-cover"
                  />
                </div>
                <span className="ml-4 text-[#17354A] text-md font-medium">
                  Elektra renovatie
                </span>
                <ChevronRight className="w-5 h-5 text-[#17354A] ml-auto" />
              </Link>
              <Link
                to="/3-fase-aansluiting"
                className="flex items-center px-3 py-2 bg-white rounded-2xl border border-[#E5E7EB] hover:border-[#17354A]/50 transition-colors duration-150"
                onClick={() => setIsDienstenOpen(false)}
              >
                <div className="w-6 h-6 flex-shrink-0 overflow-hidden rounded-lg">
                  <img
                    src="/images/meterkast.svg"
                    alt="3 fase aansluiting"
                    className="w-6 h-6 object-cover"
                  />
                </div>
                <span className="ml-4 text-[#17354A] text-md font-medium">
                  3 fase aansluiting
                </span>
                <ChevronRight className="w-5 h-5 text-[#17354A] ml-auto" />
              </Link>
              <Link
                to="/elektra-aanleggen"
                className="flex items-center px-3 py-2 bg-white rounded-2xl border border-[#E5E7EB] hover:border-[#17354A]/50 transition-colors duration-150"
                onClick={() => setIsDienstenOpen(false)}
              >
                <div className="w-6 h-6 flex-shrink-0 overflow-hidden rounded-lg">
                  <img
                    src="/images/elektra-aanleg.svg"
                    alt="Elektra aanleggen"
                    className="w-6 h-6 object-cover"
                  />
                </div>
                <span className="ml-4 text-[#17354A] text-md font-medium">
                  Elektra aanleggen
                </span>
                <ChevronRight className="w-5 h-5 text-[#17354A] ml-auto" />
              </Link>
              <Link
                to="/laadpaal"
                className="flex items-center px-3 py-2 bg-white rounded-2xl border border-[#E5E7EB] hover:border-[#17354A]/50 transition-colors duration-150"
                onClick={() => setIsDienstenOpen(false)}
              >
                <div className="w-6 h-6 flex-shrink-0 overflow-hidden rounded-lg">
                  <img
                    src="/images/ev.svg"
                    alt="Laadpaal"
                    className="w-6 h-6 object-cover"
                  />
                </div>
                <span className="ml-4 text-[#17354A] text-md font-medium">
                  Laadpaal installatie
                </span>
                <ChevronRight className="w-5 h-5 text-[#17354A] ml-auto" />
              </Link>
              <Link
                to="/zonnepanelen"
                className="flex items-center px-3 py-2 bg-white rounded-2xl border border-[#E5E7EB] hover:border-[#17354A]/50 transition-colors duration-150"
                onClick={() => setIsDienstenOpen(false)}
              >
                <div className="w-6 h-6 flex-shrink-0 overflow-hidden rounded-lg">
                  <img
                    src="/images/solar.svg"
                    alt="zonnepanelen"
                    className="w-6 h-6 object-cover"
                  />
                </div>
                <span className="ml-4 text-[#17354A] text-md font-medium">
                  Zonnepanelen installatie
                </span>
                <ChevronRight className="w-5 h-5 text-[#17354A] ml-auto" />
              </Link>
              <Link
                to="/inspectie"
                className="flex items-center px-3 py-2 bg-white rounded-2xl border border-[#E5E7EB] hover:border-[#17354A]/50 transition-colors duration-150"
                onClick={() => setIsDienstenOpen(false)}
              >
                <div className="w-6 h-6 flex-shrink-0 overflow-hidden rounded-lg">
                  <img
                    src="/images/inspectie.svg"
                    alt="inspectie"
                    className="w-6 h-6 object-cover"
                  />
                </div>
                <span className="ml-4 text-[#17354A] text-md font-medium">
                  Elektra inspectie
                </span>
                <ChevronRight className="w-5 h-5 text-[#17354A] ml-auto" />
              </Link>
            </div>
            <div className="pt-0 space-y-3">
              <a
                href="tel:+31852129778"
                className="flex items-center gap-2 text-white text-lg hover:opacity-80 hidden"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                <Phone className="w-5 h-5" />
                <span>085-2129778</span>
              </a>
              <div className="border-t border-white/20 pt-3"></div>
              <div className="space-y-3">
                {/* <Link
                  to="/ons-verhaal"
                  className="block text-white text-lg hover:opacity-80"
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  Ons verhaal
                </Link> */}
                <Link
                  to="/vacatures"
                  className="block text-white text-lg hover:opacity-80"
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  Vacatures
                </Link>
                {/* <Link
                  to="/veelgestelde-vragen"
                  className="block text-white text-lg hover:opacity-80"
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  Veelgestelde vragen
                </Link> */}
              </div>
              <Link
                to="/klantenservice"
                className="block text-white text-lg hover:opacity-80"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                Klantenservice
              </Link>
              <Link
                to="/ons-verhaal"
                className="block text-white text-lg hover:opacity-80"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                Ons verhaal
              </Link>
              <Link
                to="/contact"
                className="block text-white text-lg hover:opacity-80"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                Contact
              </Link>
            </div>
            <div className="pt-0">
              <Link
                to="/offerte"
                aria-label="Vraag een vrijblijvende offerte aan voor groepenkast vervanging"
                className="relative font-medium transition-all duration-150 leading-normal outline-none inline-flex border-2 border-transparent items-center justify-center rounded-full h-12 px-5 text-base bg-white text-[#2FB6D2] hover:bg-white/80 focus:bg-white/80 w-full"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                <span className="flex items-center gap-1">
                  Gratis offerte
                  <ChevronDown className="w-4 h-4 rotate-[-90deg]" />
                </span>
              </Link>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
export default Header;
